export const CREDIT_NOTE_LIST =  {
  data: [
    {
      "id": 6,
      "uuid": "94fdc0a0-ae54-11ea-b2ef-b34640fbc2c7",
      "organisation_id": 14,
      "customer_id": 6,
      "depot_id": null,
      "order_type_id": 4,
      "order_number": "CR11000001",
      "order_date": "2020-06-14",
      "due_date": "2020-06-26",
      "delivery_date": "2020-06-17",
      "payment_term_id": 6,
      "total_qty": "2.00",
      "total_discount_amount": "0.00",
      "total_vat": "858.10",
      "total_net": "0.00",
      "total_excise": "1560.00",
      "grand_total": "18020.10",
      "any_comment": "order delivery",
      "current_stage": "Pending",
      "current_stage_comment": null,
      "sign_image": null,
      "source": 3,
      "status": 1,
      "created_at": "2020-06-14T15: 34: 48.000000Z",
      "updated_at": "2020-06-14T15: 34: 48.000000Z",
      "deleted_at": null,
      "customer_info": {
        "id": 6,
        "user_id": 67,
        "user": {
          "id": 67,
          "firstname": "Test",
          "lastname": "Deo",
          "display_name": "Test Deo"
        }
      },
      "order_type": {
        "id": 4,
        "name": "Credit 1",
        "description": "test order credit1"
      },
      "payment_term": {
        "id": 6,
        "name": "LatestPaymentTerm",
        "number_of_days": 12
      },
      "order_details": [
        {
          "id": 10,
          "uuid": "950185d0-ae54-11ea-a365-dfd3294fce38",
          "order_id": 6,
          "item_id": 8,
          "item_uom_id": 5,
          "discount_id": null,
          "is_free": 0,
          "is_item_poi": 0,
          "promotion_id": null,
          "item_qty": "1.00",
          "item_price": "2.00",
          "item_discount_amount": "0.00",
          "item_vat": "0.10",
          "item_net": "0.00",
          "item_excise": "0.00",
          "item_grand_total": "2.10",
          "created_at": "2020-06-14T15: 34: 48.000000Z",
          "updated_at": "2020-06-14T15: 34: 48.000000Z",
          "deleted_at": null,
          "item": {
            "id": 8,
            "item_name": "New Item added"
          },
          "item_uom": {
            "id": 5,
            "name": "Test item uom",
            "code": "IU001"
          }
        },
        {
          "id": 11,
          "uuid": "95026840-ae54-11ea-9b5a-41febd0843f7",
          "order_id": 6,
          "item_id": 11,
          "item_uom_id": 5,
          "discount_id": null,
          "is_free": 0,
          "is_item_poi": 0,
          "promotion_id": null,
          "item_qty": "156.00",
          "item_price": "100.00",
          "item_discount_amount": "0.00",
          "item_vat": "858.00",
          "item_net": "0.00",
          "item_excise": "1560.00",
          "item_grand_total": "18018.00",
          "created_at": "2020-06-14T15: 34: 48.000000Z",
          "updated_at": "2020-06-14T15: 34: 48.000000Z",
          "deleted_at": null,
          "item": {
            "id": 11,
            "item_name": "item2"
          },
          "item_uom": {
            "id": 5,
            "name": "Test item uom",
            "code": "IU001"
          }
        }
      ],
      "depot": null
    },
    {
      "id": 7,
      "uuid": "610d6800-ae5a-11ea-b3d6-99b72f03e5ec",
      "organisation_id": 14,
      "customer_id": 6,
      "depot_id": null,
      "order_type_id": 4,
      "order_number": "CR111000002",
      "order_date": "2020-06-14",
      "due_date": "2020-06-26",
      "delivery_date": "2020-06-15",
      "payment_term_id": 6,
      "total_qty": "2.00",
      "total_discount_amount": "0.00",
      "total_vat": "5600.00",
      "total_net": "0.00",
      "total_excise": "10000.00",
      "grand_total": "117600.00",
      "any_comment": null,
      "current_stage": "Pending",
      "current_stage_comment": null,
      "sign_image": null,
      "source": 3,
      "status": 1,
      "created_at": "2020-06-14T16: 16: 18.000000Z",
      "updated_at": "2020-06-14T16: 16: 18.000000Z",
      "deleted_at": null,
      "customer_info": {
        "id": 6,
        "user_id": 67,
        "user": {
          "id": 67,
          "firstname": "Test",
          "lastname": "Deo",
          "display_name": "Test Deo"
        }
      },
      "order_type": {
        "id": 4,
        "name": "Credit 1",
        "description": "test order credit1"
      },
      "payment_term": {
        "id": 6,
        "name": "LatestPaymentTerm",
        "number_of_days": 12
      },
      "order_details": [
        {
          "id": 12,
          "uuid": "610fad60-ae5a-11ea-966e-39345f49c53c",
          "order_id": 7,
          "item_id": 8,
          "item_uom_id": 5,
          "discount_id": null,
          "is_free": 0,
          "is_item_poi": 0,
          "promotion_id": null,
          "item_qty": "1000.00",
          "item_price": "2.00",
          "item_discount_amount": "0.00",
          "item_vat": "100.00",
          "item_net": "0.00",
          "item_excise": "0.00",
          "item_grand_total": "2100.00",
          "created_at": "2020-06-14T16: 16: 18.000000Z",
          "updated_at": "2020-06-14T16: 16: 18.000000Z",
          "deleted_at": null,
          "item": {
            "id": 8,
            "item_name": "New Item added"
          },
          "item_uom": {
            "id": 5,
            "name": "Test item uom",
            "code": "IU001"
          }
        },
        {
          "id": 13,
          "uuid": "61101480-ae5a-11ea-a37c-3de17affc447",
          "order_id": 7,
          "item_id": 11,
          "item_uom_id": 5,
          "discount_id": null,
          "is_free": 0,
          "is_item_poi": 0,
          "promotion_id": null,
          "item_qty": "1000.00",
          "item_price": "100.00",
          "item_discount_amount": "0.00",
          "item_vat": "5500.00",
          "item_net": "0.00",
          "item_excise": "10000.00",
          "item_grand_total": "115500.00",
          "created_at": "2020-06-14T16: 16: 18.000000Z",
          "updated_at": "2020-06-14T16: 16: 18.000000Z",
          "deleted_at": null,
          "item": {
            "id": 11,
            "item_name": "item2"
          },
          "item_uom": {
            "id": 5,
            "name": "Test item uom",
            "code": "IU001"
          }
        }
      ],
      "depot": null
    }
  ]
};

export const REASONS_LIST = {
  data: [
    {
      id: 1,
      name: "Damaged Item"
    },
    {
      id: 2,
      name: "Late Delivery"
    },
    {
      id: 3,
      name: "Wrong Item"
    },
    {
      id: 4,
      name: "Not in Use"
    }
  ]
};
